import React from "react";
import { BrowserRouter, Routes, Route, useLocation, Outlet, ScrollRestoration } from "react-router-dom";
import "@/App.css";
import { Toaster } from "sonner";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Search from "@/pages/Search";
import VenueDetail from "@/pages/VenueDetail";
import AuthCallback from "@/pages/AuthCallback";
import ListYourVenue from "@/pages/ListYourVenue";
import OwnerSignup from "@/pages/OwnerSignup";
import { OwnerLayout, Overview, MyVenues, Enquiries } from "@/pages/OwnerDashboard";
import { AdminLayout, AdminOverview, AdminVenues, AdminEnquiries, AdminUsers } from "@/pages/AdminDashboard";
import AdminImport from "@/pages/AdminImport";
import SEOLandingPage from "@/pages/SEOLandingPage";
import { About, HowItWorks, Pricing, Contact, Terms, Privacy } from "@/pages/StaticPages";
import VenueOrArea from "@/pages/VenueOrArea";

function Shell() {
    const loc = useLocation();
    // Handle OAuth callback synchronously - render BEFORE routes evaluate
    if (loc.hash?.includes("session_id=")) {
        return <AuthCallback />;
    }
    return (
        <div className="min-h-screen flex flex-col">
            <Header />
            <main className="flex-1">
                <Outlet />
            </main>
            <Footer />
            <Toaster position="top-right" richColors closeButton />
        </div>
    );
}

// Scroll to top on route change
function ScrollToTop() {
    const { pathname } = useLocation();
    React.useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
    return null;
}

function App() {
    return (
        <BrowserRouter>
            <AuthProvider>
                <ScrollToTop />
                <Routes>
                    <Route element={<Shell />}>
                        <Route index element={<Home />} />
                        <Route path="/search" element={<Search />} />
                        <Route path="/list-your-venue" element={<ListYourVenue />} />
                        <Route path="/about" element={<About />} />
                        <Route path="/how-it-works" element={<HowItWorks />} />
                        <Route path="/pricing" element={<Pricing />} />
                        <Route path="/contact" element={<Contact />} />
                        <Route path="/terms" element={<Terms />} />
                        <Route path="/privacy" element={<Privacy />} />

                        {/* Owner */}
                        <Route path="/dashboard" element={<OwnerLayout />}>
                            <Route index element={<Overview />} />
                            <Route path="venues" element={<MyVenues />} />
                            <Route path="enquiries" element={<Enquiries />} />
                        </Route>
                        <Route path="/dashboard/venue/new" element={<OwnerSignup />} />

                        {/* Admin */}
                        <Route path="/admin" element={<AdminLayout />}>
                            <Route index element={<AdminOverview />} />
                            <Route path="venues" element={<AdminVenues />} />
                            <Route path="enquiries" element={<AdminEnquiries />} />
                            <Route path="users" element={<AdminUsers />} />
                            <Route path="import" element={<AdminImport />} />
                        </Route>

                        {/* Venue detail OR area landing page */}
                        <Route path="/venues/:country_slug/:city_slug/:venue_slug" element={<VenueOrArea />} />

                        {/* SEO landing pages (city, venue_type, event_type, deals, capacity) */}
                        <Route path="/venues/:country_slug/:city_slug" element={<SEOLandingPage />} />
                        <Route path="/hire/*" element={<SEOLandingPage />} />
                        <Route path="/events/*" element={<SEOLandingPage />} />
                        <Route path="/deals/*" element={<SEOLandingPage />} />
                        <Route path="/capacity/*" element={<SEOLandingPage />} />
                    </Route>
                </Routes>
            </AuthProvider>
        </BrowserRouter>
    );
}

export default App;
